const initializeOverlay = () => {
  let elementID = 'logo-animation';

  waitForElement(elementID).then((selector) => {
    triggerOverlay(elementID);
  });

  if (document.readyState == 'loading') {
    // still loading, wait for the event
    document.addEventListener('DOMContentLoaded', () => { hideOverlay(elementID) });
  } else {
    // DOM is ready!
    hideOverlay(elementID);
  }
}

const waitForElement = (elementID) => {
  return new Promise(resolve => {
      if (document.getElementById(elementID)) {
          return resolve(document.getElementById(elementID));
      }

      const observer = new MutationObserver(mutations => {
          if (document.getElementById(elementID)) {
              resolve(document.getElementById(elementID));
              observer.disconnect();
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

const triggerOverlay = (elementID) => {
  let overlayCookie = getCookie('belr_overlay_played');
  // console.log(overlayCookie);
  
  if(overlayCookie === null) {
    document.body.classList.add('show-overlay');
  }

  // player.addEventListener("rendered", (e) => {
  //   //Load via URL
  //   player.load("https://assets3.lottiefiles.com/packages/lf20_UJNc2t.json");
  // });
  
  // jlottie.loadAnimation({
  //   container: animationContainer,
  //   loop: true,
  //   autoplay: true,
  //   useWebWorker: false,
  //   path: '/app/themes/belr_theme/dist/lottiefiles/belr.json',
  // });
}

const getCookie = (name) => {
  var dc = document.cookie;
  var prefix = name + "=";
  var begin = dc.indexOf("; " + prefix);
  if (begin == -1) {
    begin = dc.indexOf(prefix);
    if (begin != 0) return null;
  }
  else
  {
    begin += 2;
    var end = document.cookie.indexOf(";", begin);
    if (end == -1) {
      end = dc.length;
    }
  }

  return decodeURI(dc.substring(begin + prefix.length, end));
} 

const setOverlaySessionCookie = (cookieName) => {  
  cookie = `${cookieName}=true; path=/`; 

  document.cookie = cookie;
}

const hideOverlay = (elementID) => {
  setTimeout(() => {
    let player = document.getElementById(elementID);
    player.pause(elementID);
    document.body.classList.remove('show-overlay');
    setOverlaySessionCookie('belr_overlay_played')
  }, 4000);
}

initializeOverlay();